import { Button } from "../../ui";
import { useSignOut } from "./session";

export function NotInvitedPage({ email }: { email: string | null }) {
  const signOut = useSignOut();
  return (
    <main className="grid min-h-dvh place-items-center bg-bg px-4">
      <div className="w-full max-w-sm rounded-xl border border-border bg-surface p-6 shadow-sm">
        <h1 className="text-xl font-semibold text-text">Not invited yet</h1>
        <p className="mt-2 text-sm text-muted">
          {email === null ? "This account" : <strong className="text-text">{email}</strong>} has not been invited to
          KitWork+. Ask an admin to invite you, then sign in again.
        </p>
        <Button className="mt-6 w-full" onClick={() => void signOut()}>
          Sign out
        </Button>
      </div>
    </main>
  );
}
